import script from "./IpTableSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./IpTableSidebar.vue?vue&type=script&setup=true&lang=js"

import "./IpTableSidebar.vue?vue&type=style&index=0&id=e24575bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e24575bc"]])

export default __exports__